import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initClarity } from './lib/clarity';
import { initGrowthTracker } from './lib/growthTracker';
initClarity();   // session replay (no-op until REACT_APP_CLARITY_ID is set)
initGrowthTracker();   // Growth OS events → track_events()
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
reportWebVitals();
